/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_OrganizationSortTime = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_OrganizationSortTime.prototype = {
    /* The view object name */
    name: 'organization',
    /* The view object instance */
    view: {
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'userVisitCrmAccount',
            basePath: '',
            rule: {
                accountId: 'organizationId'
            }
        },
    },
}

module.exports = tbs_model_vo_OrganizationSortTime